module.exports = {
        srcSet: __webpack_public_path__ + "bc1677135869f6b7-600.webp"+" 600w"+","+__webpack_public_path__ + "d17ad8e4afc4af02-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "bc1677135869f6b7-600.webp",width: 600,height: 400},{path: __webpack_public_path__ + "d17ad8e4afc4af02-1000.webp",width: 1000,height: 667}],
        src: __webpack_public_path__ + "d17ad8e4afc4af02-1000.webp",
        toString: function(){return __webpack_public_path__ + "d17ad8e4afc4af02-1000.webp"},
        
        width: 1000,
        height: 667
      }